import { AiHubLoaderService } from '@aihub/ui/loader';
import { animate, query, stagger, style, transition, trigger } from '@angular/animations';
import { Component } from '@angular/core';
import { Observable } from 'rxjs';
import { EstimateService } from 'projects/estimate/src/app/estimate.service';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatMenuModule } from '@angular/material/menu';
import { MatTabsModule } from '@angular/material/tabs';


@Component({
  standalone: true,
  selector: 'app-estimate-loading',
  templateUrl: './estimate-loading.component.html',
  styleUrls: ['./estimate-loading.component.scss'],
  animations: [
    trigger('listAnimation', [
      transition('* <=> *', [ // each time the binding value changes
        query(':leave', [
          stagger(100, [
            animate('1.5s', style({ opacity: 0 }))
          ])
        ], { optional: true }),
        query(':enter', [
          style({ opacity: 0 }),
          stagger(100, [
            animate('1.5s', style({ opacity: 1 }))
          ])
        ], { optional: true })
      ])
    ])
  ],
  imports: [
    CommonModule,
    MatCardModule,
    MatTooltipModule,
    MatMenuModule,
    MatTabsModule
  ]
})

export class EstimateLoadingComponent {

  public timeSensitiveDetails$: Observable<Array<string>> = this.progress.timeSensitiveDetails.asObservable();
  public selectedProjectType$: Observable<string> = this.progress.selectedProjectType.asObservable();
  public projectHeadline$: Observable<string> = this.progress.projectHeadline.asObservable();

  // loading
  public disablePage$ = this.progress.disablePage.asObservable()
  public isLoading$ = this.loaderService.loader$.asObservable();
  public selectedIndex$: Observable<number> = this.progress.tabChange.asObservable();

  constructor(private progress: EstimateService, private loaderService: AiHubLoaderService
  ) { }

}
